import './index.css';
import ReactDOM from 'react-dom/client';
import FleetApp from './App.tsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/id';
import { initSentry } from './libs/sentry';

// Initialize Sentry as early as possible
initSentry();

dayjs.extend(utc);
dayjs.locale('id');

ReactDOM.createRoot(document.getElementById('root')!).render(<FleetApp />);
